import { lazy } from 'react';
import withSuspense from 'utils/withSuspense';
const FrontappConfigPage = lazy(() => import('features/frontapp/components/FrontappConfigPage'));

const FrontappConfigIndexRoute = withSuspense(FrontappConfigPage);

export default FrontappConfigIndexRoute;
